// @flow
/* *import * as strings from "../../strings"
**************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import CreatePaymentAgreement from "./CreatePaymentAgreement"
import Invoices from "./Invoices"
import Payments from "./Payments"
import Verification from "./Verification"
import Stepper from "react-stepper-horizontal"
import AlertBox from "../../components/CreatePaymentAgreementComponents/AlertBox"
import { Dialog } from "react-toolbox/lib/dialog"
import { Button } from "react-toolbox/lib/button"
import * as strings from "../../strings"
import { connect } from "react-redux"
import queryString from "query-string"
import { toastr } from "react-redux-toastr"
import { formatDateToShortDate } from "../../utils"
import _ from "lodash"
import {
  getProcedureByContactId,
  newPaymentAgreement,
  getDebtById,
  getAllInterestTypes,
} from "../../actions"

class CreatePaymentAgreementPage extends Component {
  props: {
    getProcedure: any,
    getProcedureByContactId: any,
    getDebt: any,
    getDebtById: any,
    newPaymentAgreement: any,
    interestTypes: mixed[],
    getAllInterestTypes: () => any,
    history: {
      push: () => {}
    },
    match: {
      path: string,
      params: {
        debtId: string,
      },
    },
  }

    state = {
      activeSubmit: false,
      active: false,
      dialogText: undefined,
      currentStep: 0,
      notOnlyOneSubType: false,
      isPreLitigation: false,
      paymentAgreementState: {
        clientName: undefined,
        checkBoxes: {},
        isAllCheckBoxesSelected: false,
        debtValue: 0,
        capitalValue: 0,
        numberOfPayments: undefined,
        valuePerPayment: undefined,
        firstPaymentDate: new Date(),
        paymentDates: [],
        payments: [],
        isChangedPayment: [],
        interestValue: 0,
        newInvoices: [],
        justiceTax: undefined,
        interestRate: 0,
        arePaymentInputsValid: [ false, false, false ],
        isClientValid: false,
        isByPayments: false,
        idInterestType: 0,
        taxValue: undefined,
        debtorChecked: undefined,
        type: undefined,
        isCollective: undefined,
        debtorId: undefined,
        pickedInvoices: [],
        addedInvoices: [],
      },
    }

  componentWillMount = () => {
    this.props.getDebtById( parseInt( this.props.match.params.debtId, 10 ) ).then( () => {
      const parsedURL = queryString.parse( location.search )
      const debtorId = parsedURL.debtorId
      const mainDebtor = this.props.getDebt.debtDebtors.
        find( debtDebtor => _.isEqual( this.props.getDebt.idDebtor, debtDebtor.debtor.id ) )
      return this.setState( {
        paymentAgreementState: {
          ...this.state.paymentAgreementState,
          debtorChecked: this.props.getDebt.idDebtor,
          isCollective: mainDebtor.debtor.isCollective,
          debtorId: debtorId,
        },
      } )
    } )
    if ( this.props.interestTypes.length === 0 ) {
      this.props.getAllInterestTypes()
    }
  }

  checkInput = ( input ) => {
    const errorMessage = <span> {strings.errorMessages.missingField} </span>
    const errorNegativeValueMessage = <span> {strings.errorMessages.invalidValue} </span>
    if ( input != null) {
      return input < 0 ? errorNegativeValueMessage : false
    } else {
      return errorMessage
    }
  }

  getMainDebtorsInfo = () => {
    const { getDebt } = this.props
    let debtDebtor
    if ( getDebt.length !== 0 ) {
      debtDebtor = getDebt.debtDebtors.find( debtor =>
        debtor.debtor.id === getDebt.idDebtor )
    }
    const clientName = debtDebtor ? debtDebtor.debtor.contact.name : strings.errorMessages.emptyField
    return {
      clientName,
    }
  }

  nextStepClick = () => {
    const paymentAgreementState = this.state.paymentAgreementState
    const state = this.state
    const validInputs = [
      this.checkInput( paymentAgreementState.numberOfPayments ),
      this.checkInput( paymentAgreementState.valuePerPayment ),
      this.checkInput( paymentAgreementState.justiceTax ),
    ]

    if ( state.currentStep < 4 ) {
      switch ( state.currentStep ) {
      case 0:
        _.compact( Object.values( paymentAgreementState.checkBoxes ) ).length === 0
          || paymentAgreementState.type === undefined
            || paymentAgreementState.isCollective === undefined ?
          this.setState( {
            dialogText: <div className={style.confirmDiv}>
              <h1 className={style.tableTitle}>{strings.errorMessages.missingFields}</h1></div>,
            active: !state.active,
          } )
          :
          this.setState( {
            paymentAgreementState: {
              ...this.state.paymentAgreementState,
              ...this.getMainDebtorsInfo(),
            },
            currentStep: state.currentStep + 1,
          } )
        break
      case 1:
        !_.isEqual( paymentAgreementState.pickedInvoices.length, 0 ) ||
          !_.isEqual( paymentAgreementState.addedInvoices.length, 0 ) ?
          this.setState( {
            currentStep: state.currentStep + 1,
          } )
          :
          this.setState( {
            dialogText: <div className={style.confirmDiv}>
              <h1 className={style.tableTitle}> {strings.invoices.pickInvoice} </h1></div>,
            active: !state.active,
          } )
        break
      case 2:
        if ( validInputs.every( input => input === false ) ) {
          this.setState( {
            currentStep: state.currentStep + 1,
          } )
        } else {
          this.setState( {
            paymentAgreementState: {
              ...paymentAgreementState,
              arePaymentInputsValid: validInputs,
            },
          } )
        }
        break
      case 3:
        this.setState( {
          dialogText: <div className={style.confirmDiv}>
            <h1 className={style.tableTitle}>{strings.paymentAgreements.endPaymentAgreement}</h1></div>,
          activeSubmit: !state.activeSubmit,
        } )
        break
      }
    }
  }

  returnStepClick = () => {
    if ( this.state.currentStep > 0 ) {
      this.setState( {
        currentStep: this.state.currentStep - 1,
      } )
    }
  }

  returnDebt = () => {
    this.props.history.push( "/debt/" + this.props.getDebt.id )
  }

  handleChange = ( newValue, callBack ) => {    
    return this.setState( {
      paymentAgreementState: {
        ...this.state.paymentAgreementState,
        ...newValue,
      },
    }, callBack )
  }

  handleToggleStep = ( activeState ) => () => {
    if ( activeState === this.state.active ) {
      this.setState( {
        active: !activeState,
      } )
    } else {
      this.setState( {
        activeSubmit: !activeState,
      } )
    }
  }

  setUpPaymentAgreement = () => {
    const { generalStrings } = strings
    const paymentAgreementState = this.state.paymentAgreementState

    const selectedPreLitigationIds = _.filter(
      paymentAgreementState.checkBoxes,
      ( _value, key ) => key.startsWith( strings.processes.preLitigationProcedureTag )
    )

    const selectedLitigationIds = _.filter(
      paymentAgreementState.checkBoxes,
      ( _value, key ) => key.startsWith( strings.processes.litigationProcedureTag )
    )

    const plannedPayments = paymentAgreementState.payments.map( ( payment, i ) => {
      return {
        value: payment.toString(),
        expiryDate: formatDateToShortDate( paymentAgreementState.paymentDates[ i ] ),
        paymentStatus: generalStrings.waiting,
      }
    } )

    const existentInvoices = paymentAgreementState.pickedInvoices.map( invoice => invoice.id )
    const newInvoices = paymentAgreementState.addedInvoices.map( newInvoice => {
      return {
        ...newInvoice,
        value: newInvoice.value.toString(),
        date: formatDateToShortDate( newInvoice.date ),
        expiryDate: formatDateToShortDate( newInvoice.expiryDate ),
      }
    } )

    return {
      capitalValue: paymentAgreementState.capitalValue.toString(),
      interestValue: paymentAgreementState.interestValue.toString(),
      justiceTax: paymentAgreementState.justiceTax.toString(),
      type: paymentAgreementState.type,
      isCollective: paymentAgreementState.isCollective,
      status: "Draft",
      invoices: newInvoices,
      existentInvoices,
      plannedPayments,
      idDebt: parseInt( this.props.match.params.debtId, 10 ),
      idDebtor: paymentAgreementState.debtorChecked,
      debtPhases: {
        litigationIds: selectedLitigationIds,
        preLitigationIds: selectedPreLitigationIds,
        executionIds: [],
      },
    }
  }

  registerPaymentAgreement = () => {

    const debtId = _.parseInt( this.props.match.params.debtId )
    this.handleToggleStep( this.state.activeSubmit )

    const newPaymentAgreement = this.setUpPaymentAgreement()
    this.props.newPaymentAgreement( newPaymentAgreement )
      .then( () => toastr.success( strings.generalStrings.paymentAgreementAdded ) )
      .catch( () => toastr.error( strings.generalStrings.errorAddingPaymentAgreement ) )
    this.setState( {
      activeSubmit: !this.state.activeSubmit,
    } )
    this.props.getDebtById( parseInt( debtId ) )
      .then( () => this.props.history.push( "/debt/" + this.props.getDebt.id ) )
  }

  render () {
    const parsedURL = queryString.parse( location.search )
    const debtorId = parsedURL.debtorId

    let componentToRender = <div />
    const { generalStrings } = strings
    const paymentAgreementState = this.state.paymentAgreementState

    const active = this.state.active
    const state = this.state
    const isFirstStep = state.currentStep === 0

    function checkSubTypeSelected(type) {
      let plList = []
      let lList = []

      for(var o in paymentAgreementState.checkBoxes){
        if(paymentAgreementState.checkBoxes[o] !== undefined){
          if(o.includes(strings.processes.preLitigationProcedureTag)){
            plList.push(paymentAgreementState.checkBoxes[o])
          } else {
            lList.push(paymentAgreementState.checkBoxes[o])
          }
        }
      }
    
      if(type === 'notOnlyOneSubType')
        return (plList.length > 0 && lList.length > 0) ? true : false
      else if(type === 'isPreLitigation')
        return (plList.length > 0 && !(lList.length > 0)) ? true : false
      else 
        return null
    }
    
    switch ( state.currentStep ) {
    case 0:
      componentToRender = (
        <CreatePaymentAgreement
          paymentAgreementState={paymentAgreementState}
          onChange={this.handleChange}
          debtorId={debtorId}
          debt={this.props.getDebt}
        />
      )
      break

    case 1:
      componentToRender = (
        <Invoices
          debt={this.props.getDebt}
          paymentAgreementState={paymentAgreementState}
          onChange={this.handleChange}
          isPreLitigation={checkSubTypeSelected('isPreLitigation')}
        />
      )
      break

    case 2:
      componentToRender = (
        <Payments
          paymentAgreementState={paymentAgreementState}
          onChange={this.handleChange}
          interestTypes={this.props.interestTypes}
          isPreLitigation={checkSubTypeSelected('isPreLitigation')}
        />
      )
      break

    case 3:
      componentToRender = (
        <Verification
          procedures={this.props.getProcedure}
          debt={this.props.getDebt}
          paymentAgreementState={paymentAgreementState}
          onChange={this.handleChange}
        />
      )
      break
    }

    return (
      <div className={style.mainContainer}>
        <Dialog
          className={style.dialogBoxFormat}
          actions={[
            { label: generalStrings.ok, onClick: this.handleToggleStep( active ) },
          ]}
          active={active}
          onEscKeyDown={this.handleToggleStep( active )}
          onOverlayClick={this.handleToggleStep( active )}>
          <AlertBox message={state.dialogText} />
        </Dialog>
        <Dialog
          className={style.dialogBoxFormat}
          actions={[
            { label: generalStrings.cancel, onClick: this.handleToggleStep( state.activeSubmit ) },
            { label: generalStrings.submit, onClick: this.registerPaymentAgreement },
          ]}
          active={state.activeSubmit}
          onEscKeyDown={this.handleToggleStep( state.activeSubmit )}
          onOverlayClick={this.handleToggleStep( state.activeSubmit )}>
          <AlertBox message={state.dialogText} />
        </Dialog>
        <div className={style.header} >
          <div className={style.stepper}>
            <Stepper
              steps={ [
                { title: strings.processes.selectProcesses },
                { title: strings.invoices.verifyInvoices },
                { title: strings.paymentAgreements.agreedPaymentAgreementTitle },
                { title: generalStrings.verifying },
              ] }
              activeStep={state.currentStep}
            />
          </div>
        </div>
        <div>
          {componentToRender}
        </div>
        <div className={style.nextButton}>
          <Button onClick={this.returnDebt} label={generalStrings.cancel} flat />
          <Button onClick={this.returnStepClick} label={generalStrings.return} disabled={ isFirstStep }/>
          <Button onClick={this.nextStepClick} label={generalStrings.next} flat disabled={ checkSubTypeSelected('notOnlyOneSubType') } />
        </div>
      </div>
    )
  }
}

const mapStateToProps = ( store ) => {
  return {
    getProcedure: store.getProcedure,
    paymentAgreements: store.paymentAgreements,
    getDebt: store.getDebt,
    interestTypes: store.interestTypes,
  }
}

export default connect( mapStateToProps,
  { getProcedureByContactId, newPaymentAgreement, getDebtById, getAllInterestTypes } )( CreatePaymentAgreementPage )



// WEBPACK FOOTER //
// ./src/views/CreatePaymentAgreementPage/index.js